export const daysOfWeek = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

export const columnLabels = {
  Facility_Type: "Facility Type",
  Facility_Owner_Type: "Facility Owner Type",
  tenantId: "Tenant ID",
  partnerId: "Partner ID",
  Facility_ID : "Facility ID",
  Facility_Name: "Facility Name",
  Facility_Description : "Facility Description",
  "Facility_Address.address1": "Address Line 1",
  "Facility_Address.address2": "Address Line 2",
  "Facility_Address.pincode": "Pincode",
  "Facility_Address.country": "Country",
  "Facility_Address.city": "City",
  "Facility_Address.state": "State",
  Facility_StorageType: "Storage Type",
  Facility_Capacity: "Capacity",
  "Facility_OperationalDaysAndHours.dayRange": "Operational Day",
  "Facility_OperationalDaysAndHours.timeRange.open": "Opening Time",
  "Facility_OperationalDaysAndHours.timeRange.close": "Closing Time",
  "Facility_ManagerDetails.firstName": "Manager First Name",
  "Facility_ManagerDetails.lastName": "Manager Last Name",
  "Facility_ManagerContact.mobile": "Manager Mobile",
  "Facility_ManagerContact.alternateMobile": "Alternate Mobile",
  "Facility_ManagerContact.email": "Manager Email",
  Facility_DockDetails: "Dock Details",
  Facility_OtherDetails: "Other Details",
  status: "Status",
  createdBy: "Created By",
  updatedBy: "Updated By",
  createdAt: "Created Date",
  updatedAt: "Updated Date"
};

export const defaultVisibleFields = [
  "Facility_ID",
  "Facility_Name",
  "Facility_Type",
  "Facility_Owner_Type",
  "Facility_Address.address1",
  "Facility_Address.pincode",
  "Facility_Capacity",
  "Facility_ManagerDetails.firstName",
  "Facility_ManagerContact.mobile",
  "status"
];

export const getColumnWidth = (fieldName) => {
  const widthMap = {
    Facility_Name: 180,
    Facility_Type: 140,
    Facility_Owner_Type: 160,
    "Facility_Address.address1": 180,
    "Facility_Address.pincode": 120,
    Facility_Capacity: 120,
    "Facility_ManagerDetails.firstName": 150,
    "Facility_ManagerContact.mobile": 150,
    status: 100,
    createdAt: 160,
    updatedAt: 160
  };

  return widthMap[fieldName] || 160;
};

export const getValueFormatter = (fieldName) => {
  switch (fieldName) {
    // case "Facility_Capacity":
    //   return (params) =>
    //     params ? `${Number(params.value).toLocaleString()} units` : "";
    // case "Facility_ManagerContact.mobile":
    // case "Facility_ManagerContact.alternateMobile":
    //   return (params) =>
    //     params && params.value ? `${params.value}` : "";
    // case "status":
    //   return (params) =>
    //      params == 1 ? "Active" : "Inactive";
    // case "createdAt":
    // case "updatedAt":
    //   return (params) =>
    //     params
    //       ? new Date(params).toLocaleString()
    //       : "";
    default:
      return undefined;
  }
};

export const getColumnLabel = (field, startCaseFn) => {
  return columnLabels[field] || startCaseFn(field);
};


export const unflattenPartnerObject = (flatObj) => {
  const result = {};

  Object.entries(flatObj).forEach(([key, value]) => {
    const keys = key.split(".");
    let current = result;

    keys.forEach((k, i) => {
      if (i === keys.length - 1) {
        current[k] = value;
      } else {
        current[k] = current[k] || {};
        current = current[k];
      }
    });
  });

  return result;
};


export function parseOperationalHours(operationalHours) {
  if (!operationalHours) return [];

  return operationalHours.split(',').map(item => {
    // Normalize full-width colon or weird spaces
    item = item.replace(/：/g, ':').trim();

    // Split on the first colon only
    const [dayRaw, ...timeParts] = item.split(':');
    const timeRaw = timeParts.join(':').trim(); // join back in case time has extra colon

    // Normalize day capitalization
    const day = daysOfWeek.find(d => d.toUpperCase() === dayRaw.trim().toUpperCase()) || dayRaw.trim();

    let open = null, close = null;

    if (timeRaw) {
      // Normalize all dash types to standard '-'
      const normalizedTime = timeRaw.replace(/[–—−]/g, '-'); // en dash, em dash, minus sign
      const [o, c] = normalizedTime.split('-').map(str => str.trim());
      open = o || null;
      close = c || null;
    }

    console.log({
      dayRange: day,
      timeRange: { open, close }
    });
    

    return {
      dayRange: day,
      timeRange: { open, close }
    };
  });
}
